import { CommonRequest, Method, ServiceName, CommonResponse } from 'models/common/RestApi';
import { SetupExcpParam, ItemList } from 'models/setup/excp/excp';
import { SetupProject } from 'models/setup/SetupProject';

import { callApi } from 'utils/ApiUtil';

export const getSetupItemList = async (condition: SetupExcpParam) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/itemList`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...condition,
    }),
  };
  const response: CommonResponse<ItemList[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as ItemList[];
};

export const saveItemList = async (condition: ItemList) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/setup/saveSetupPakItem`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: condition,
  };
  const response: CommonResponse<string> = await callApi(request);
  return response;
};

export const getProjectItemCnt = async (condition: SetupExcpParam) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/itemListCnt`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...condition,
    }),
  };
  const response: CommonResponse<SetupExcpParam> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as SetupExcpParam;
};

export const callPackage = async (condition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/eqpSpRltCpltPkg`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      prjId: condition.prjId,
      xlsUploadId: condition.xlsUploadId,
    }),
  };
  const response: CommonResponse<any> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as any;
};
